<!-- Unused file deprecated -->
<template>
  <div>{{ 'Component to view details of portal' }}</div>
</template>
